import { IImgToBlobOptions, TApplicationFileType, TFileType, TImageFileType } from '.';

export const DEFAULT_IMG_TO_BLOB_OPTIONS: IImgToBlobOptions = {
  mimeType: 'image/jpeg',
  maxSize: 1280,
  qualityFactor: 0.92,
  transparencyColor: '#FFFFFF'
};

export const ACCEPTABLE_IMAGE_FILE_MIME_TYPES: TImageFileType[] = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/heic',
  'image/heif'
];
export const ACCEPTABLE_APPLICATION_FILE_MIME_TYPES: TApplicationFileType[] = ['application/json', 'application/xml'];

export const ACCEPTABLE_FILE_MIME_TYPES: TFileType[] = [
  ...ACCEPTABLE_IMAGE_FILE_MIME_TYPES,
  ...ACCEPTABLE_APPLICATION_FILE_MIME_TYPES
];
